// src/data/Bottles.js

export const bottles = [
  {
    id: 1,
    name: 'Doukkala Petite (Blue)',
    volume: '250 ml',
    weight: '0.5',
    img: 'https://brokepiggytoken.xyz/wp-content/uploads/2025/07/Harvest2024-Bluesmall.png',
    price: '€28.17',
    harvestYear: '2024',
    description: 'A lively olive oil with bright green herbaceous notes, balanced by a soft almond sweetness and a gentle peppery finish.',
    region: 'Doukkala',
    grade: 'Extra Virgin',
    press: 'First Cold Press',
    worksWith: ['Salads', 'Grilled Vegetables', 'Fresh Bread'],
    tastingNotes: ['Herbaceous', 'Almond', 'Peppery'],
  },

  
  {
    id: 2,
    name: 'Doukkala Petite (Yellow)',
    volume: '250 ml',
    weight: '0.5',
    img: 'https://brokepiggytoken.xyz/wp-content/uploads/2025/07/Harvest2024-Yellowsmall.png',
    price: '€28.17',
    harvestYear: '2024',
    description:
      'A lively olive oil with bright green herbaceous notes, balanced by a soft almond sweetness and a gentle peppery finish.',
    // Short Information
    region: 'Doukkala',
    grade: 'Extra Virgin',
    press: 'First Cold Press',
    // Works-with pairings
    worksWith: ['Soups', 'Roasted Meats', 'Artisan Bread'],
    // Tasting notes
    tastingNotes: ['Ripe Fruit', 'Warm Spice'],
  },

  {
    id: 3,
    name: 'Doukkala Grande (Blue)',
    volume: '750 ml',
    weight: '1.25',
    img: 'https://brokepiggytoken.xyz/wp-content/uploads/2025/07/Marrakech-reserve-750ml-transparent.png',
    price: '€66.90',
    harvestYear: '2024',
    description:
      'Delivered in a grand bottle, this olive oil brings bright green herbaceous notes, balanced by a soft almond sweetness and a gentle peppery finish.',
    // Short Information
    region: 'Doukkala',
    grade: 'Extra Virgin',
    press: 'First Cold Press',
    // Works-with pairings
    worksWith: ['Soups', 'Roasted Meats', 'Artisan Bread'],
    // Tasting notes
    tastingNotes: ['Ripe Fruit', 'Warm Spice'],
  },

];

// keep your existing varietal map
export const detailsMap = {
  1: [
    { label: 'Batch Doukkala',  color: '#11403b' },
    { label: 'Organic',         color: '#c79a3d' },
    { label: 'Medium',          color: '#81b29a' },
    { label: 'Monovarietal', color: '#e07a5f' },
  ],
  2: [
    { label: 'Batch Doukkala', color: '#11403b' },
    { label: 'Organic',         color: '#c79a3d' },
    { label: 'Medium',          color: '#81b29a' },
    { label: 'Monovarietal',    color: '#e07a5f' },
  ],
   3: [
    { label: 'Batch Doukkala', color: '#11403b' },
    { label: 'Organic',         color: '#c79a3d' },
    { label: 'Medium',          color: '#81b29a' },
    { label: 'Monovarietal',    color: '#e07a5f' },
  ],
};
